import {Injectable} from "@angular/core";

@Injectable()
export class TfFilterSearchService {

  constructor() {
  }

  filterBySearch(optionsArray, searchValue: string, filterValue: string) {
    const filteredOptions: any = [];
    const filterQuery = filterValue.trim().toLowerCase();
    if (optionsArray && optionsArray.length > 0) {
      for (const option of optionsArray) {
        if ((option[searchValue].trim().toLowerCase()).indexOf(filterQuery) !== -1) {
          filteredOptions.push(option);
        }
      }
    }
    return filteredOptions;
  }

}
